/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GuardType = {
    None: 'None',
    Children: 'Children',
    Self: 'Self'
} as const;
export type GuardType = typeof GuardType[keyof typeof GuardType];


export function instanceOfGuardType(value: any): boolean {
    for (const key in GuardType) {
        if (Object.prototype.hasOwnProperty.call(GuardType, key)) {
            if (GuardType[key as keyof typeof GuardType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GuardTypeFromJSON(json: any): GuardType {
    return GuardTypeFromJSONTyped(json, false);
}

export function GuardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuardType {
    return json as GuardType;
}

export function GuardTypeToJSON(value?: GuardType | null): any {
    return value as any;
}

export function GuardTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GuardType {
    return value as GuardType;
}

